const BRAND_NAME_PATTERN = /chatwoot|4pillars/gi;

export const getInstallationName = () =>
  window.globalConfig?.INSTALLATION_NAME || 'Chatwoot';

export const getBrandLogo = () =>
  window.globalConfig?.LOGO || '/brand-assets/logo.png';

export const getBrandThumbnail = () =>
  window.globalConfig?.LOGO_THUMBNAIL || '/brand-assets/logo_thumbnail.png';

export const replaceBrandNames = (value, brandName = getInstallationName()) => {
  if (typeof value === 'string') {
    return value.replace(BRAND_NAME_PATTERN, brandName);
  }

  if (Array.isArray(value)) {
    return value.map(item => replaceBrandNames(item, brandName));
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        key,
        replaceBrandNames(item, brandName),
      ])
    );
  }

  return value;
};
